/**
 * admin_user.workspace_perms 기반 워크스페이스(ENTIRE) 메뉴 접근
 * - null / undefined: 허용 없음 (미설정·기본)
 * - []: 허용 메뉴 없음
 * - ['schedule', ...]: 화이트리스트 (전체 허용은 레지스트리 전체 id가 담긴 배열로 저장)
 */

export function userMayAccessWorkspaceCard(user, cardId, isSuper) {
  if (isSuper) return true;
  const w = user?.workspace_perms;
  if (w === null || w === undefined) return false;
  if (!Array.isArray(w)) return false;
  return w.includes(cardId);
}
